import { render, staticRenderFns } from "./YachtTypeRow.vue?vue&type=template&id=3f5bd5d6&"
import script from "./YachtTypeRow.vue?vue&type=script&lang=js&"
export * from "./YachtTypeRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports